










































































































































































































import Vue from "vue";
import { ADD_MODIFIER, UPDATE_MODIFIER } from "@/queries/user/mutation.graphql";
import { GET_MODIFIERS } from "@/queries/user/query.graphql";

export default Vue.extend({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    selectedModifier: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      modifier: null,
      items: [],
    };
  },
  computed: {
    menuId() {
      return this.$store.getters["userModule/menuId"];
    },
  },
  methods: {
    oncloseInput(e, item, close) {
      console.log(item);
      if (!e.input) {
        this.items = this.items.filter((el) => el.name !== item.name);
      } else {
        console.log(e);

        close();
        item.name = e.input;
        setTimeout(() => {
          item.price = e.other;
        });
      }
    },
    onPriceEnter(item, callback) {
      this.edit(item.name, item, callback);
    },
    addOrEdit() {
      if (this.selectedModifier) {
        this.editModifier();
      } else {
        this.addModifier();
      }
    },
    addModifier() {
      this.items.forEach((el, index) => {
        if (!el.name.length) {
          this.items.splice(index, 1);
        }
      });
      this.items = this.items.map((el, i) => {
        const { fresh, justadd, ...rest } = el;
        return { ...rest, sortIndex: i };
      });
      if (!this.items.length) {
        this.$toastr.e("You should insert at least one item", "Error occured");
        return;
      }
      if (!this.modifier.name.length) {
        this.$toastr.e("You should insert modifier name", "Error occured");
        return;
      }

      const modifier = {
        ...this.modifier,
        menuId: this.menuId,
        items: this.items,
      };
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: ADD_MODIFIER,
          variables: {
            ...modifier,
          },
          update: (cache, { data: { insert_Modifier } }) => {
            if (insert_Modifier) {
              const data: any = cache.readQuery({
                query: GET_MODIFIERS,
              });

              data.Modifier.push({
                ...insert_Modifier.returning[0],
                ...this.modifier,
                menuId: this.menuId,
              });

              cache.writeQuery({
                query: GET_MODIFIERS,
                data,
              });
            }
          },
        })
        .then(() => {
          this.loading = false;
          this.onClose();
          this.$toastr.s(
            "Item added successfuly to your modifirs",
            "Item Added"
          );
        })
        .catch(() => {
          this.loading = false;
          this.$toastr.e("", "Error occured");
        });
    },
    closeMultipleOnEdit(item, close) {
      if (item.fresh) {
        this.items = this.items.filter((el) => el.name !== item.name);
      } else {
        if (item.name.length) {
          close();
        }
      }
    },
    editModifier() {
      const items = [];
      const objects = [];
      const modifierId = this.modifier["id"];
      this.items.forEach((el, index) => {
        items.push(el.name);
        objects.push({
          name: el.name,
          price: el.price,
          modifierId,
          sortIndex: index,
        });
      });

      this.$apollo
        .mutate({
          mutation: UPDATE_MODIFIER,
          variables: {
            items,
            objects,
            modifierId,
            itemMax: this.modifier.itemMax,
            name: this.modifier.name,
            totalMax: this.modifier.totalMax,
            totalMin: this.modifier.totalMin,
          },
          update: (cache, { data: { c } }) => {
            if (c) {
              const data: any = cache.readQuery({
                query: GET_MODIFIERS,
              });

              data.Modifier = data.Modifier.filter(
                (el) => el.id !== c.returning[0].id
              );
              data.Modifier.push(c.returning[0]);

              cache.writeQuery({
                query: GET_MODIFIERS,
                data,
              });
            }
          },
        })
        .then(() => {
          this.loading = false;
          this.onClose();
          this.$toastr.s("Updated successfuly");
        })
        .catch(() => {
          this.loading = false;
          this.$toastr.e("Error occured");
        });
    },
    initiateModifier() {
      if (this.selectedModifier) {
        const { ModifierItems, ...rest } = this.selectedModifier;
        this.modifier = rest;
        this.items = ModifierItems;
      } else {
        this.modifier = {
          name: "",
          itemMax: 1,
          totalMax: 1,
          totalMin: 0,
        };
        // this.items = [];
        // this.addItem();
      }
    },
    onDelete(index) {
      this.items.splice(index, 1);
    },
    validateNoOpenItem() {
      let isOpen = false;
      this.items.forEach((el) => {
        if (el.fresh && el.name.length === 0) {
          isOpen = true;
        }
      });
      return isOpen;
    },
    addItem() {
      if (this.validateNoOpenItem()) {
        // this.$toastr.e("", "Please add the above item first");
        return;
      }
      this.items.push(this.Item());
    },
    onClose() {
      this.$emit("close", false);
      this.items = [];
      this.modifier = null;
    },
    edit(value, item, callback) {
      if (value.trim().length === 0) {
        this.$toastr.e("You should insert one character at list!");
        if (item.justadd && item.fresh) {
          this.items = this.items.filter((el) => el.name !== item.name);
        }
        return;
      }

      if (item.fresh) {
        const { fresh, justadd, ...rest } = item;
        this.items[this.items.length - 1] = { ...rest, fresh, name: value };
      }
      callback();
    },
    Item(name = "", price = 0) {
      const sortIndex = this.items.length;
      return {
        name,
        price,
        sortIndex,
        fresh: true,
        justadd: true,
      };
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.initiateModifier();
      }
    },
  },
});
